//@flow
import type { SignUpSIMCardScanActionType } from './actions';

export const initialState: SIMCardScanStateType = {
  SIMSerialNumber: '',
};

export default (state: SIMCardScanStateType = initialState, action: SignUpSIMCardScanActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_SIM_CARD_NUMBER':
      return {
        ...state,
        SIMSerialNumber: action.payload.SIMSerialNumber,
      };
    default:
      return state;
  }
};

export type SIMCardScanStateType = {|
  SIMSerialNumber: string,
|};

export const SIMSerialNumberSelector = (state: any) => state.signUp.simCardScan.SIMSerialNumber;
